const unitTypes = {
  division: "Division",
  asset: "Asset",
  investment_plan: "Investment plan",
};
export default unitTypes;
